import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const ActionClose_lg = (props) => {
    const width = props.width ? props.width + 'px' : '32px';
    const height = props.height ? props.height + 'px' : '32px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 32 32"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L16 14.5858L26.2929 4.29289C26.6834 3.90237 27.3166 3.90237 27.7071 4.29289C28.0976 4.68342 28.0976 5.31658 27.7071 5.70711L17.4142 16L27.7071 26.2929C28.0976 26.6834 28.0976 27.3166 27.7071 27.7071C27.3166 28.0976 26.6834 28.0976 26.2929 27.7071L16 17.4142L5.70711 27.7071C5.31658 28.0976 4.68342 28.0976 4.29289 27.7071C3.90237 27.3166 3.90237 26.6834 4.29289 26.2929L14.5858 16L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z"
            />
        </SvgStyled>
    );
};

export default ActionClose_lg;
